var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text',{staticClass:"e-svg-text-wrap"},[_vm._l((_vm.lines),function(line,index){return _c('tspan',{key:`t-${index}`,attrs:{"x":"0","dy":_vm.getLineHeight(index)}},[_vm._v(" "+_vm._s(line)+" ")])}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }